import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IIdItem } from '../../../spacesPlatform/models/resourceParts';

export interface ISetDatasourceRemoteAgentReservationParams extends IIdItem {
  remoteAgentReservationId: string;
}

export interface ISetDatasourceRemoteAgentReservationResult extends IResult {
  updatedRemoteAgentName: string;
}

export class SetDatasourceRemoteAgentReservationRequest
  extends Request<ISetDatasourceRemoteAgentReservationParams, ISetDatasourceRemoteAgentReservationResult> {

  constructor(params: ISetDatasourceRemoteAgentReservationParams) {
    super('setDatasourceRemoteAgentReservation', params);
  }
}
